import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/base/Breadcrumb";
import SectionTitle from "@/components/base/SectionTitle";
import { rankData } from "@/mocks/mangaData";

const genreFilter = ["全部类型", "奇幻", "科幻", "推理", "治愈", "热血", "青春", "古风"];

export default function Rank() {
  return (
    <>
      <Navbar />
      <main className="mx-auto w-full max-w-7xl px-4 py-8 md:px-6 md:py-12">
        <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "评分排行" }]} />
        <div className="mt-6">
          <SectionTitle
            eyebrow="评分排行"
            title="漫画e站读者口碑排行"
            desc="由注册漫友对作品剧情、画工、人设与更新质量的综合打分实时汇总，还原真实口碑，帮你快速锁定值得追的作品。"
          />
        </div>

        <div className="mt-7 flex flex-wrap gap-2">
          {genreFilter.map((g, i) => (
            <button
              key={g}
              type="button"
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                i === 0
                  ? "bg-primary-500 font-medium text-background-50"
                  : "bg-background-100 text-foreground-700 hover:bg-background-200"
              }`}
            >
              {g}
            </button>
          ))}
        </div>

        <div className="mt-8 overflow-hidden rounded-2xl border border-background-200 bg-background-50">
          <div className="hidden grid-cols-12 gap-4 border-b border-background-200 bg-background-100 px-5 py-3 text-xs font-medium text-foreground-500 sm:grid">
            <span className="col-span-1">排名</span>
            <span className="col-span-4">作品</span>
            <span className="col-span-3">类型</span>
            <span className="col-span-2">评分</span>
            <span className="col-span-2">参与人数</span>
          </div>
          {rankData.map((r) => (
            <div
              key={r.id}
              className="grid grid-cols-12 items-center gap-4 border-b border-background-200 px-5 py-4 transition-colors last:border-0 hover:bg-background-50"
            >
              <div className="col-span-2 sm:col-span-1">
                <span
                  className={`flex h-9 w-9 items-center justify-center rounded-lg font-heading text-sm font-bold ${
                    r.rank <= 3 ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-800"
                  }`}
                >
                  {r.rank}
                </span>
              </div>
              <div className="col-span-6 sm:col-span-4">
                <div className="flex items-center gap-2">
                  <h3 className="font-heading text-base font-bold text-foreground-950">{r.title}</h3>
                  <span className="rounded-full bg-background-200 px-2 py-0.5 text-xs text-foreground-600">
                    {r.tag}
                  </span>
                </div>
              </div>
              <div className="col-span-4 text-sm text-foreground-600 sm:col-span-3">{r.genre}</div>
              <div className="col-span-4 flex items-center gap-1 text-sm font-semibold text-primary-700 sm:col-span-2">
                {r.score}
                {r.change === "up" && <i className="ri-arrow-up-line text-xs text-accent-500"></i>}
                {r.change === "down" && <i className="ri-arrow-down-line text-xs text-secondary-600"></i>}
              </div>
              <div className="col-span-4 text-sm text-foreground-500 sm:col-span-2">
                {r.votes.toLocaleString()}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-3">
          {[
            { icon: "ri-user-star-line", t: "四维评分", d: "剧情、画工、人设与更新质量均衡加权，避免单一维度拉高分数。" },
            { icon: "ri-shield-check-line", t: "反刷分机制", d: "系统自动识别异常打分，保证排行的真实与公平。" },
            { icon: "ri-refresh-line", t: "每周更新", d: "评分实时汇总，排行每周整档发布，紧跟口碑变化。" },
          ].map((f) => (
            <div key={f.t} className="rounded-2xl border border-background-200 bg-background-100 p-5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                <i className={`${f.icon} text-lg`}></i>
              </span>
              <h3 className="mt-3 text-sm font-semibold text-foreground-950">{f.t}</h3>
              <p className="mt-1.5 text-sm leading-6 text-foreground-600">{f.d}</p>
            </div>
          ))}
        </div>
      </main>
      <Footer />
    </>
  );
}